export default function PHP_lcg_value() {
  return (
    <div>
      <h1>PHP_lcg_value</h1>
    </div>
  );
}
